import "./index.scss";

const Avatar = (props) => {
  const { nameInitials, className = "" } = props;
  return (
    <div className={`user-avatar ${className}`}>
      {nameInitials.charAt(0).toUpperCase()}
    </div>
  );
};

export default Avatar;
